<template>
    <div
        :class="[
            userLvl < element.lvl && !canEdit && userRole !== 2 ? 'bg-black-abs': '',
        ]"
        class="table-row body">
        <div :style="{
            width: '10%'
        }" class="row-item br-l">
            <span class='px-6 py-2 text-center'>{{ index + 1 }}</span>
        </div>
        <div :style="{
            width: !canEdit ? '75%' : '55%'
        }" class="row-item">
            <span class='px-6 py-2'>{{ element.title }}</span>
        </div>
        <div
            v-if="userRole === 2 && canEdit"
            style="width: 10%;"
            class="row-item"
        >
            <span class='px-6 py-2'>
                <span
                    :class="element.is_confirmed ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'"
                    class="text-xs font-medium px-2.5 py-0.5 rounded"
                >
                    {{ element.is_confirmed ? 'Активна' : 'Неактивна' }}
                </span>
            </span>
        </div>
        <div
            v-if="userLvl >= element.lvl || canEdit || userRole === 2"
            style='width: 15%;' class="row-item">
            <span class='px-6 py-2'>
                <button @click="setIndex(element.uuid)"
                    class="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button" style="width: 100%;">
                    Конспект
                </button>
            </span>
        </div>
        <div v-if="canEdit" style="width: 15%;" class="row-item bt-n ">
            <div class="px-4 flex-center fl-start inl-100 center">
                <div class='mr-2'>
                    <svg 
                        @click="updateModal(
                            element.uuid,
                            index + 1,
                            element.title,
                        )"
                        class="w-5 h-5 text-n-blue feather feather-edit" fill="none" stroke="currentColor"
                        stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24"
                        xmlns="http://www.w3.org/2000/svg">
                        <path class='text-n-blue' d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                        <path class='text-n-blue' d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                    </svg>
                </div>
                <div class='mr-2'>
                    <svg 
                        @click="updateModal(
                            null,
                            index + 1,
                            null,
                        )"
                        class="w-5 h-5 text-gray-600 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 5.757v8.486M5.757 10h8.486M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                    </svg>
                </div>
                <div class='mr-2'>
                    <svg 
                        @click="openDeleteModal(element.uuid,)"
                        class="w-5 h-5 text-red-500 text-gray-800 dark:text-white" aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 20">
                        <path class='text-red-500' stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                            stroke-width="2"
                            d="M1 5h16M7 8v8m4-8v8M7 1h4a1 1 0 0 1 1 1v3H6V2a1 1 0 0 1 1-1ZM3 5h12v13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5Z" />
                    </svg>
                </div>
            </div>
        </div>

        <div v-if="[0,3].includes(userRole)" style="width: 15%;" class="row-item br-l">
            <div style="display: block;" class="w-full px-5 ">
                <button 
                    @click="toggleConfirm(element)"
                    :class="element.is_confirmed 
                        ? 'bg-gray-400' 
                        : 'bg-green-500 hover:bg-green-600'"
                    class="text-white font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md transition-all duration-150 w-full"
                    type="button"
                >
                    {{ element.is_confirmed ? "Отменить" : "Подтвердить" }}
                </button>
            </div>
        </div>

    </div>
</template>

<script>
import { API_CLIENT, HEADERS_TOKEN_JSON } from '@/const/uri';
import axios from 'axios';
export default {
    methods: {
        async toggleConfirm(item) {
            try {
                const resp = await axios.post(
                    API_CLIENT.tsorThemes + item.uuid + '/toggle_confirm/',
                    {},
                    { headers: HEADERS_TOKEN_JSON() }
                )
                item.is_confirmed = resp.data.data.is_confirmed
                this.$emit('updateStatus', { uuid: item.uuid, is_confirmed: item.is_confirmed })
            } catch (e) {
                console.log(e)
                alert('Ошибка при изменении статуса')
            }
        },
    },
    props: {
        element: {},
        userRole: {},
        index: {},
        setIndex: {},
        updateModal: {},  
        openDeleteModal: {},  
        canEdit: {},
        userLvl: {},
    }
}
</script>